module.exports = __webpack_public_path__ + "asset/pharos_privacy_policy--91a66a.pdf";